import { createContext, useContext, useEffect, useMemo, useState } from "react";

const STORAGE_KEY_CAT = "ncs_vehicle_category";
const STORAGE_KEY_PLATE = "ncs_vehicle_plate";

export const CATEGORIES = {
  A: {
    id: "A",
    label: "Catégorie A",
    name: "Micro / très petites voitures",
    examples: "Smart, Twingo, C1, Aygo, Up!",
    prices: { exterieur: 50, interieur: 70, pack: 100, concession: 150 },
  },
  B: {
    id: "B",
    label: "Catégorie B",
    name: "Citadines / Compactes / Berlines",
    examples: "208, Clio, Mégane, Golf",
    prices: { exterieur: 60, interieur: 80, pack: 120, concession: 170 },
  },
  C: {
    id: "C",
    label: "Catégorie C",
    name: "SUV / Breaks / Monospaces / 4x4",
    examples: "X5, X6, 3008, 5008, Espace",
    prices: { exterieur: 70, interieur: 90, pack: 140, concession: 190 },
  },
  D: {
    id: "D",
    label: "Catégorie D",
    name: "Utilitaire / 9 places / Van",
    examples: "Kangoo, Trafic, Master, Porsche",
    prices: { exterieur: 0, interieur: 0, pack: 0, concession: 0 },
  },
};

export const CATEGORY_LIST = ["A", "B", "C", "D"].map((k) => CATEGORIES[k]);

const VehicleContext = createContext(null);

export function VehicleProvider({ children }) {
  const [category, setCategoryState] = useState(null);
  const [plate, setPlateState] = useState("");
  const [selectorOpen, setSelectorOpen] = useState(false);

  useEffect(() => {
    const savedCat = localStorage.getItem(STORAGE_KEY_CAT);
    if (savedCat && CATEGORIES[savedCat]) setCategoryState(savedCat);
    const savedPlate = localStorage.getItem(STORAGE_KEY_PLATE);
    if (savedPlate) setPlateState(savedPlate);
  }, []);

  const setCategory = (cat) => {
    setCategoryState(cat);
    if (cat) localStorage.setItem(STORAGE_KEY_CAT, cat);
    else localStorage.removeItem(STORAGE_KEY_CAT);
  };

  const setPlate = (p) => {
    const clean = (p || "").toUpperCase().trim();
    setPlateState(clean);
    if (clean) localStorage.setItem(STORAGE_KEY_PLATE, clean);
    else localStorage.removeItem(STORAGE_KEY_PLATE);
  };

  const openSelector = () => setSelectorOpen(true);
  const closeSelector = () => setSelectorOpen(false);

  const getPrice = (serviceId) => {
    if (!category) return null;
    return CATEGORIES[category].prices[serviceId] ?? null;
  };

  const value = useMemo(() => ({
    category,
    categoryData: category ? CATEGORIES[category] : null,
    plate,
    setCategory,
    setPlate,
    getPrice,
    selectorOpen,
    openSelector,
    closeSelector,
  }), [category, plate, selectorOpen]);

  return (
    <VehicleContext.Provider value={value}>
      {children}
    </VehicleContext.Provider>
  );
}

export const useVehicle = () => {
  const ctx = useContext(VehicleContext);
  if (!ctx) throw new Error("useVehicle must be used within VehicleProvider");
  return ctx;
};
